module.exports = __webpack_public_path__ + "static/shopify_1-6407020d6fb193b2cb23b39e8b602b89.png";